'use client'

import styles from './product-styles.module.css'

import { clsx } from 'clsx'
import React from 'react'

import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { trackClickDashboardGroup } from '@/utils/tracker/modules/prioritas'

import { ContainerNoPadding } from '@/components/Container'
import { LazyImg } from '@/components/LazyImg'

import { ProductCardItem, productCards } from './data'
import { FaqSection } from './FaqSection'

const ProductLogoItem = ({
  product,
  onClick,
}: {
  product: ProductCardItem
  onClick: (product: ProductCardItem) => void
}) => {
  return (
    <button
      role="button"
      key={product.id}
      data-testid={`item-${product.id}`}
      className={clsx(
        'flex cursor-pointer flex-col items-center justify-center gap-2 border-subdued bg-white px-2 py-8 text-center'
      )}
      onClick={() => {
        onClick(product)
      }}
    >
      {product.logoUrl ? (
        <>
          {product.logoExtraUrl ? (
            <div className="flex flex-wrap items-center justify-center gap-2">
              <LazyImg
                src={product.logoUrl}
                alt={product.text}
                height={40}
                width={40}
                useCdn={true}
                withWebp={true}
                className="h-auto max-h-[40px] w-auto"
              />
              <Separator
                orientation="vertical"
                style={{
                  width: 2,
                  height: 40,
                }}
              />
              <LazyImg
                src={product.logoExtraUrl}
                alt={product?.extraText || ''}
                height={40}
                width={40}
                useCdn={true}
                withWebp={true}
                className="h-auto max-h-[40px] w-auto"
              />
            </div>
          ) : (
            <LazyImg
              src={product.logoUrl}
              alt={product.text}
              height={60}
              width={60}
              useCdn={true}
              withWebp={true}
              className="h-auto max-h-[60px] w-auto"
            />
          )}

          {product.withText && <Text variant="body-bold">{product.text}</Text>}
        </>
      ) : (
        <>
          <div className="h-16 w-16 rounded-full bg-gray-30" />
        </>
      )}
    </button>
  )
}

export const ProductLogoList = () => {
  const handleClickProduct = (item: ProductCardItem) => {
    trackClickDashboardGroup(item.text)

    const element = document.getElementById(`row-${item.id}`)
    if (element && element.getBoundingClientRect) {
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset

      if (window.scrollTo) {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      }
    }
  }

  return (
    <>
      <div className="relative -mt-[26rem] bg-transparent md:-mt-56 lg:-mt-[10.4rem]">
        <ContainerNoPadding className="bg-transparent">
          <Text
            className="mx-4 mb-4 md:mx-0"
            variant="heading-md"
            color="inverse"
          >
            Daftar Platform
          </Text>
          <nav
            className={clsx(
              'z-10 mx-4 grid grid-cols-1 rounded-2xl bg-white md:mx-0 md:grid-cols-2 lg:grid-cols-3',
              styles.productList
            )}
          >
            {productCards.map((product: ProductCardItem) => (
              <ProductLogoItem
                key={product.text}
                product={product}
                onClick={handleClickProduct}
              />
            ))}
          </nav>
        </ContainerNoPadding>
      </div>
      <FaqSection />
    </>
  )
}
